import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";

export function useSessions({ adminMode = false } = {}) {
  const [sessions, setSessions] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    let query = supabase.from("sessions").select("*").order("school_id");
    if (!adminMode) query = query.eq("visible", true);
    query.then(({ data, error }) => {
      if (error) setError(error.message);
      else setSessions(data ?? []);
      setLoading(false);
    });
  }, [adminMode]);

  return { sessions, loading, error };
}
